// extracted by mini-css-extract-plugin
export default {"appbarContainer":"Admin_appbarContainer__1BkSe"};